module.exports = __webpack_public_path__ + "static/media/karan.1ab48a8f.jpg";